function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
import { ACTIVITYWAY, PLANVERSION, ShieldingAlipayChannelId, ShieldingAlipayProjects } from "../utils/constants";
import { getLocalAccessToken } from "../utils/getToken";
import { getActivityDetailById, getActivityDetailByXfield, quereGroupInfoByIdAndType, queryOrderByActId } from "./api";
import { getTemplateInfo } from "./courseTemplateService";
import moment from 'moment';
import { getUserLoginInfo } from "./userInfo";
/**
 * 获取虚拟库存
 * @param startTime 活动开始时间
 * @param endTime 活动结束时间
 * @param allStock 活动配置显示库存
 */
export var getVirtualStock = function getVirtualStock(startTime, endTime, stock, id) {
  var start = new Date(startTime === null || startTime === void 0 ? void 0 : startTime.replace(/\-/g, '/')).getTime();
  var end = new Date(endTime === null || endTime === void 0 ? void 0 : endTime.replace(/\-/g, '/')).getTime();
  var now = Date.now();
  // 如果还未开始，以start为now
  now = start > now ? start : now;
  if (start === end) {
    return stock;
  }
  // 按时间比例返回库存
  return Math.ceil((end - now) / (end - start) * stock);
};

/**
 * 根据route参数及search参数用不同方式获取活动商品信息
 */
export var getActivityInfoByParamsOrSearch = function getActivityInfoByParamsOrSearch(params, search) {
  if (!!(search !== null && search !== void 0 && search['channel']) && !!search['x_field_1']) {
    return getActivityDetailByXfield(search['x_field_1']);
  }
  // url参数中有活动id
  if (params !== null && params !== void 0 && params.activityId) {
    return getActivityDetailById(params === null || params === void 0 ? void 0 : params.activityId);
  }
  // url search中有x_field_1
  if (search !== null && search !== void 0 && search['x_field_1']) {
    return getActivityDetailByXfield(search['x_field_1']);
  }
  return new Promise(function (resolve, reject) {
    reject('无商品信息');
  });
};

/**
 * 获取商品信息
 * @param params 路由上的信息
 * @param search location.search 上携带的信息
 */
export var getProductInfo = function getProductInfo(params, search) {
  return new Promise(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(resolve, reject) {
      var data, activity, templateConfigId, templateInfo, time, timeOver, localToken, layerStatus, hasBuy, orderGroupInfo, urlGroupInfo, orderInfo, orderProduct, qaAnswer, skipPayment, buyRes, status, result, groupRes, _groupRes, details0, isMaster, userId, orderId, _yield$getUserLoginIn, StudentId, product, i, _i, expired, showIndexLink, hasShowOnlyBuy, hasDisabled, productType, isTrial;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getActivityInfoByParamsOrSearch(params, search);
          case 2:
            data = _context.sent;
            if (!(!(data !== null && data !== void 0 && data.status) && data !== null && data !== void 0 && data.result)) {
              _context.next = 78;
              break;
            }
            activity = data.result; // 获取模板信息-- 如果有模板配置 优先显示模板配置内容
            _context.prev = 5;
            templateConfigId = activity.templateConfigId;
            _context.next = 9;
            return getTemplateInfo(templateConfigId);
          case 9:
            templateInfo = _context.sent;
            Object.assign(activity, templateInfo, {});
            _context.next = 15;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](5);
          case 15:
            time = moment();
            if (time.isBefore(activity.startTime)) {
              timeOver = -1; // Before
            } else if (time.isBetween(activity.startTime, activity.endTime)) {
              timeOver = 0; // Between
            } else {
              timeOver = 1; // After
            }
            activity.timeOver = timeOver; // timeOver: -1 | 0 | 1; // 时间是否过期  -1 之前 0 当前 1 过期
            _context.next = 20;
            return getLocalAccessToken();
          case 20:
            localToken = _context.sent;
            // 挽留层是否显示判断
            layerStatus = data.result.layerStatus; // 购买状态，默认未购买
            hasBuy = 0;
            orderGroupInfo = null;
            urlGroupInfo = null;
            orderInfo = null;
            orderProduct = null;
            qaAnswer = null;
            skipPayment = (activity === null || activity === void 0 ? void 0 : activity.ext) && !!JSON.parse(activity === null || activity === void 0 ? void 0 : activity.ext).skipPayment; // 已经登录获取当前商品购买历史
            if (!localToken) {
              _context.next = 44;
              break;
            }
            _context.next = 32;
            return queryOrderByActId({
              act_id: activity.id
            });
          case 32:
            buyRes = _context.sent;
            status = buyRes.status, result = buyRes.result;
            qaAnswer = !status && result ? result.surveyAnswerDto : null;
            // 请求ok && 有订单 && 支付成功
            if (!(!status && result && result.orderInfo.payState === 3)) {
              _context.next = 44;
              break;
            }
            hasBuy = 1;
            orderInfo = result.orderInfo;
            orderProduct = result.orderProduct;

            // 如果是拼团 获取团信息
            if (!(activity.activityWay === ACTIVITYWAY.groupon)) {
              _context.next = 44;
              break;
            }
            _context.next = 42;
            return quereGroupInfoByIdAndType(buyRes.result.orderInfo.orderToken, 1);
          case 42:
            groupRes = _context.sent;
            orderGroupInfo = groupRes.result;
          case 44:
            if (!search.groupId) {
              _context.next = 56;
              break;
            }
            _context.next = 47;
            return quereGroupInfoByIdAndType(search.groupId, 0);
          case 47:
            _groupRes = _context.sent;
            urlGroupInfo = _groupRes.result;
            // s假拼团 用户是团长逻辑
            details0 = urlGroupInfo && urlGroupInfo.details && urlGroupInfo.details[0] || {}; // 拿到团长信息
            isMaster = details0.isMaster, userId = details0.userId, orderId = details0.orderId;
            _context.next = 53;
            return getUserLoginInfo();
          case 53:
            _yield$getUserLoginIn = _context.sent;
            StudentId = _yield$getUserLoginIn.userInfo.StudentId;
            // 拿到用户登录信息
            // 假拼团&&团长===当前登录用户 && orderId===0
            if (isMaster === 1 && userId === StudentId && orderId === '0') {
              hasBuy = 1;
              orderGroupInfo = urlGroupInfo;
            }
          // e假拼团 用户是团长逻辑
          case 56:
            product = null; // 已购买 && 订单有商品信息
            if (hasBuy && orderProduct && orderProduct.productId) {
              for (i = 0; i < activity.products.length; i++) {
                if (activity.products[i].id === orderProduct.productId) {
                  product = activity.products[i];
                }
              }
            }
            // 如果url参数中有商品id，则为预选商品
            else if (!!params.productId && activity.products && activity.products.length) {
              for (_i = 0; _i < activity.products.length; _i++) {
                if (activity.products[_i].id === params.productId) {
                  product = activity.products[_i];
                }
              }
            }

            // 已禁用 || 已过期 --> 均识别为已过期
            expired = !activity.activityStatus; // 是否显示首页入口
            showIndexLink = !activity.channelDeliveryVersion || activity.channelDeliveryVersion.version !== PLANVERSION.NotLinkToIndex;
            /* start 秒杀根据落地页状态等展示内容调整 */
            hasShowOnlyBuy = true; // 同是否未购买
            hasDisabled = false; // 按钮是否Disabled
            productType = orderProduct ? orderProduct.productType : 0; // 根据这个状态显示按钮文字
            isTrial = activity.channelDeliveryVersion.isTrial; // 是否是轻课
            _context.t1 = timeOver;
            _context.next = _context.t1 === -1 ? 67 : _context.t1 === 0 ? 70 : _context.t1 === 1 ? 72 : 74;
            break;
          case 67:
            hasDisabled = true;
            productType = 5;
            return _context.abrupt("break", 75);
          case 70:
            hasShowOnlyBuy = !!hasBuy;
            return _context.abrupt("break", 75);
          case 72:
            // 没有登录
            if (!localToken) {
              productType = 6;
            } else {
              // 未购买
              if (!hasBuy) {
                hasDisabled = true;
                productType = 7;
              }
            }
            return _context.abrupt("break", 75);
          case 74:
            return _context.abrupt("break", 75);
          case 75:
            /* end 秒杀根据落地页状态等展示内容调整 */
            resolve({
              activity: activity,
              products: activity.products,
              product: product,
              hasBuy: hasBuy,
              expired: expired,
              showIndexLink: showIndexLink,
              orderGroupInfo: orderGroupInfo,
              urlGroupInfo: urlGroupInfo,
              orderInfo: orderInfo,
              orderProduct: orderProduct,
              qaAnswer: qaAnswer,
              layerStatus: layerStatus,
              hasDisabled: hasDisabled,
              hasShowOnlyBuy: hasShowOnlyBuy,
              productType: productType,
              isTrial: isTrial,
              skipPayment: skipPayment
            });
            _context.next = 79;
            break;
          case 78:
            reject();
          case 79:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 13]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

// 屏蔽相关渠道支付宝支付
export var hiddenAlipay = function hiddenAlipay(channelId, projectId) {
  return ShieldingAlipayChannelId.includes(+channelId) && ShieldingAlipayProjects.includes(+projectId);
};